import { addDays, addHours } from 'date-fns';
import { getUTCMidDay } from 'utils/date';
import { DirectSignupFiltersFormType } from '../schemas/filtersSchema';
import { isNumber } from 'lodash';
import { captureException } from '@sentry/react';

/** Evaluations can be scheduled up to this date in the future */
export const MAX_DAYS_FOR_FIRST_EVALUATION = 21;

/** How many days from today to wait before first day that can be picked for evaluation */
export const DEFAULT_EVALUATION_OFFSETS = {
  INSURANCE: 3,
  PRIVATE_PAY: 3,
};

/** Using current date, returns the range of dates that can be picked for evaluation */
export const getEvaluationSchedulingWindow = (
  paymentMethod: DirectSignupFiltersFormType['paymentMethod'],
): {
  from: Date;
  to: Date;
} => {
  const today = getUTCMidDay();

  let from: Date;
  const to = addDays(today, MAX_DAYS_FOR_FIRST_EVALUATION);

  switch (paymentMethod.type) {
    case 'privatePay':
      from = addDays(today, DEFAULT_EVALUATION_OFFSETS.PRIVATE_PAY);
      break;
    case 'insurance':
      if (isNumber(paymentMethod.insuranceData.evalLeadTime)) {
        from = addHours(today, paymentMethod.insuranceData.evalLeadTime);
      } else {
        from = addDays(today, DEFAULT_EVALUATION_OFFSETS.INSURANCE);
      }
      break;
    default:
      captureException(
        new Error(`Reached end of getEvaluationTimeFrames without a proper return, defaulting to private pay offset`),
        {
          data: JSON.stringify({
            paymentMethod,
          }),
        },
      );
      from = addDays(today, DEFAULT_EVALUATION_OFFSETS.PRIVATE_PAY);
      break;
  }

  return {
    from,
    to,
  };
};
